import { render, staticRenderFns } from "./BillOfLoads.vue?vue&type=template&id=19fb5116&scoped=true"
import script from "./BillOfLoads.vue?vue&type=script&lang=js"
export * from "./BillOfLoads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fb5116",
  null
  
)

export default component.exports